import React, { FC, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment, { Moment } from "moment";

import CtaComponent from "../../../components/reusable-ui/cta";
import CustomDropdown from "../../../components/reusable-ui/custom-dropdown";

import { CTA_SIZE, CTA_TYPE, DATE_TIME_FORMATS } from "../../../data/constants";
import { convertMomentToString } from "../../../helpers/moment-helper";
import { RootState } from "../../../redux/store";
import { AGGREGATOR_TYPE } from "../../../data/outlet-status-constants";
import { Checkbox } from "@mui/material";
import { getAggregatorLogo } from "../../../helpers/accounting-helper";
import { cloneDeep, set } from "lodash";
import "./style.scss";
import { FilterDataType, ReconContext } from "./recon-context";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
type configType = {
  aggregator: "zomato" | "swiggy" | "";
  branches: string[];
  dateRange: [Moment | null, Moment | null] | null;
}

const TopActionBar: FC = () => {
  const { reconContextData: { reportsViewData: { uploadedReports }, filterData }, updateFilterData, applyFilters, resetFilters } = useContext(ReconContext);
  const { businessBranchesDataMap, allChannelsDefDataMap } = useSelector(
    (state: RootState) => ({
      businessBranchesDataMap: state.businessReducer.businessBranchesDataMap,
      allChannelsDefDataMap: state.businessReducer.allChannelsDefDataMap,
    })
  );
  const DROPDOWN_CONFIGS = {
    aggregator: {
      optionsMap: { swiggy: { id: "swiggy", label: "Swiggy" }, zomato: { id: "zomato", label: "Zomato" } },
      placeholder: "Select Aggregator",
      uniqueKey: "id",
      addEmptyOption: true,
      parentClass: "w-1/5 max-w-[190px]",
      key: "aggregator",
      getListItemText: (data: any) => data?.label,
    },
    branches: {
      optionsMap: businessBranchesDataMap,
      placeholder: "Select Branch",
      uniqueKey: "branchId",
      isMultiSelect: true,
      dropdownHeading: "Branches",
      searchPlaceholder: "Search a branch",
      parentClass: "w-1/5 max-w-[170px]",
      key: "branchIds",
      getListItemText: (data: any) => data?.branchName,
    },
    channelDefId: {
      optionsMap: allChannelsDefDataMap,
      placeholder: "Select Channel",
      uniqueKey: "channelDefId",
      dropdownHeading: "Channels",
      searchPlaceholder: "Search a channel",
      parentClass: "w-1/5 max-w-[170px] ml-[12px]",
      key: "channelDefId",
      getListItemText: (data: any) => data?.name,
    },
  };

  const handleFilterChange = (value: any, fieldToUpdate: string) => {
    let dataToUpdate = cloneDeep(filterData);
    set(dataToUpdate, fieldToUpdate, value);
    updateFilterData(dataToUpdate);
  };

  const onDateRangeSubmission = (data: any) => {
    handleFilterChange(data, 'dateRange');
  };

  /**
   * The dates more than 3 years will always be disabled
   * @param current
   */
  const disabledDate = (current: any) => {
    return (
      current &&
      (current >= moment().endOf("day") || moment().diff(current, "days") > 364)
    );
  };

  function renderCustomDropDown(dropdownConfig: {
    optionsMap: any;
    placeholder?: string;
    getListItemText?: any;
    parentClass?: string;
    dropdownHeading?: string;
    searchPlaceholder?: string;
    uniqueKey: any;
    key: string;
    isMultiSelect?: boolean;
    addEmptyOption?: boolean;
  }): any {
    return (
      <CustomDropdown
        addEmptyOption={dropdownConfig.addEmptyOption}
        optionsMap={dropdownConfig.optionsMap}
        isMultiSelect={dropdownConfig.isMultiSelect}
        placeholder={dropdownConfig.placeholder}
        getListItemText={dropdownConfig.getListItemText}
        parentClass={dropdownConfig.parentClass}
        dropdownHeading={dropdownConfig.dropdownHeading}
        searchPlaceholder={dropdownConfig.searchPlaceholder}
        onSubmit={(value: any) => {
          handleFilterChange(dropdownConfig.isMultiSelect ? value : value[0], dropdownConfig.key)
        }
        }
        preSelectedValues={filterData[dropdownConfig.key as keyof FilterDataType ]}
        uniqueKey={dropdownConfig.uniqueKey}
        showErrorBox={false}
      ></CustomDropdown>
    );
  }

  function handleResetFilters() {
    resetFilters();
  }

  function renderApplyAndResetCtas() {
    let enableApplyCta =
      filterData?.dateRange?.[0] &&
      filterData?.dateRange?.[1];

    return <>
      {filterData.applied && <CtaComponent
        ctaText="Reset Filter"
        ctaSize={CTA_SIZE.small}
        ctaType={CTA_TYPE.primary_cta}
        onCtaClick={handleResetFilters}
        customClass={"ml-auto text-[#D94242] text-[14px] font-medium"}
      />}
      <CtaComponent
        ctaText="Apply"
        ctaSize={CTA_SIZE.small}
        ctaType={CTA_TYPE.active_cta}
        onCtaClick={applyFilters}
        customClass={filterData.applied ? "" : "ml-auto"}
        isDisabled={!enableApplyCta}
      />
    </>
  }

  //If either filter applied or reports present then show filter bar
  if (!uploadedReports.totalFiles && !filterData.applied) return <></>

  return (
    <div className="top-action-bar flex items-center px-[14px] py-[10px] bg-white relative gap-[12px]">
      <RangePicker
        value={filterData.dateRange}
        format={DATE_TIME_FORMATS.dayMonthYear}
        disabledDate={disabledDate}
        onChange={onDateRangeSubmission}
      />
      {renderCustomDropDown(DROPDOWN_CONFIGS.aggregator)}
      {renderCustomDropDown(DROPDOWN_CONFIGS.branches)}
      {/* {renderCustomDropDown(DROPDOWN_CONFIGS.channelDefId)} */}
      {renderApplyAndResetCtas()}
    </div>
  );
};

export default TopActionBar;
